import * as types from 'mutation-types'
import model from 'api'
import { setSessionStorage, getSessionStorage } from 'utils/storage'

const state = {
  list: [],
  total: 0,

  snKey: '',
  condition: getSessionStorage('sn_list_condition') || {
    snStatus: '',
    systemId: '',
    username: '',
    pageNo: 1,
    pageSize: 15,
    snHex: ''
  },

  loadingList: false
}

const getters = {
  searchList (state) {
    return state.list.filter(item => {
      return item.sn.indexOf(state.snKey) > -1
    })
  }
}

const mutations = {
  [types.SN_SET_LIST] (state, { list, total }) {
    state.list = list
    state.total = total
  },
  [types.SN_SET_SN_KEY] (state, snKey) {
    state.snKey = snKey
  },
  [types.SN_UPDATE_LIST_CONDITION] (state, data) {
    state.condition = Object.assign(state.condition, data)
  },

  [types.SN_SET_LIST_LOADING] (state, loading) {
    state.loadingList = loading
  }
}

const actions = {
  async getList ({ commit, state }) {
    try {
      commit(types.SN_SET_LIST_LOADING, true)
      const { list, total } = await model.SN.getList(state.condition)
      commit(types.SN_SET_LIST, { list, total })
    } catch (e) {
      commit(types.SN_SET_LIST, { list: [], total: 0 })
    } finally {
      setSessionStorage('sn_list_condition', state.condition)
      commit(types.SN_SET_LIST_LOADING, false)
    }
  },
  setListCondition ({ commit, dispatch }, data) {
    commit(types.SN_UPDATE_LIST_CONDITION, data)
    dispatch('getList')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
